import { render, staticRenderFns } from "./AddonParticipants.vue?vue&type=template&id=6068f59a&scoped=true&"
import script from "./AddonParticipants.vue?vue&type=script&lang=js&"
export * from "./AddonParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6068f59a",
  null
  
)

export default component.exports